var _CloseCircle;
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import { jsx as _jsx } from "react/jsx-runtime";
var CleanIcon = function CleanIcon(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: "tw-flex tw-items-center tw-mr-1.6",
    onClick: onClick,
    children: _CloseCircle || (_CloseCircle = /*#__PURE__*/_jsx(CloseCircle, {
      size: 16,
      className: "tw-text-neutral-light-600 hover:tw-text-primary-light-500 dark:tw-text-neutral-dark-500 dark:hover:tw-text-primary-dark-400"
    }))
  });
};
export default CleanIcon;